import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async open_shift(data) {
    let response = await apiCall(
      "attendence_management/Open_pump_attendant_shift",
      data
    );
    return response;
  },

  async close_shift(data) {
    let response = await apiCall(
      "attendence_management/close_pump_attendant_shift",
      data
    );
    return response;
  },
  async list_Attendance(data) {
    let response = await apiCall(
      "attendence_management/list_active_attendence_sessions",
      data
    );
    return response;
  },
  // async list_Pumps(data) {
  //   let response = await apiCall("fuel_pumps/list_fuel_pumps", data);
  //   return response;
  // },
  // async update_Pumps(data) {
  //   let response = await apiCall("fuel_pumps/update_fuel_pump", data);
  //   return response;
  // },
};
